import { render, staticRenderFns } from "./orderDetails.vue?vue&type=template&id=7f73a46e&scoped=true&"
import script from "./orderDetails.vue?vue&type=script&lang=js&"
export * from "./orderDetails.vue?vue&type=script&lang=js&"
import style0 from "./orderDetails.vue?vue&type=style&index=0&id=7f73a46e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f73a46e",
  null
  
)

export default component.exports